/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取订单列表数量
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  memberId: string,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: order.IPage<order.EsOrderInfo>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/order/orders/${memberId}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
